//
//
//
//
//
//
//
//
//

var script = {
  name: "DarkMode",
  data: function data() {
    return {
      darkMode: null
    };
  },
  mounted: function mounted() {
    if (localStorage.getItem("darkMode") == 'true') {
      this.darkMode = true;
    } else {
      this.darkMode = false;
    }
    this.checkColorScheme();
  },
  methods: {
    switchColorScheme: function switchColorScheme(bool) {
      var el = document.querySelector("body");
      if (bool) {
        localStorage.setItem("darkMode", true);
        el.classList.add("theme-dark");
      } else {
        localStorage.setItem("darkMode", false);
        el.classList.remove("theme-dark");
      }
    },
    checkColorScheme: function checkColorScheme() {
      if (
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches &&
        localStorage.getItem("darkMode") === null
      ) {
        this.darkMode = true;
      }
    }
  },
  watch: {
    darkMode: function(val) {
      console.log("eseguo");
      this.switchColorScheme(val);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

var isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return function (id, style) { return addStyle(id, style); };
}
var HEAD;
var styles = {};
function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        var code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                { style.element.setAttribute('media', css.media); }
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            var index = style.ids.size - 1;
            var textNode = document.createTextNode(code);
            var nodes = style.element.childNodes;
            if (nodes[index])
                { style.element.removeChild(nodes[index]); }
            if (nodes.length)
                { style.element.insertBefore(textNode, nodes[index]); }
            else
                { style.element.appendChild(textNode); }
        }
    }
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "a",
    {
      staticClass: "action",
      on: {
        click: function($event) {
          _vm.darkMode = !_vm.darkMode;
        }
      }
    },
    [
      !_vm.$slots.lightIcon && _vm.darkMode
        ? _c("b", [_vm._v("🌞")])
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.lightIcon && _vm.darkMode ? _vm._t("lightIcon") : _vm._e(),
      _vm._v(" "),
      !_vm.$slots.darkIcon && !_vm.darkMode
        ? _c("b", [_vm._v("🌜")])
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.darkIcon && !_vm.darkMode ? _vm._t("darkIcon") : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-44cdb753_0", { source: ".action {\n  cursor: pointer;\n}\n\n/*# sourceMappingURL=DarkMode.vue.map */", map: {"version":3,"sources":["/Users/pierdomenicoreitano/Documents/Projects/vue-dark-mode-switcher/src/components/DarkMode.vue","DarkMode.vue"],"names":[],"mappings":"AAwDA;EACA,eAAA;ACvDA;;AAEA,uCAAuC","file":"DarkMode.vue","sourcesContent":["<template>\n  <a class=\"action\" @click=\"darkMode = !darkMode\">\n    <b v-if=\"!$slots.lightIcon && darkMode\">🌞</b>\n    <slot name=\"lightIcon\" v-if=\"$slots.lightIcon && darkMode\"></slot>\n    <b v-if=\"!$slots.darkIcon && !darkMode\">🌜</b>\n    <slot name=\"darkIcon\" v-if=\"$slots.darkIcon && !darkMode\"></slot>\n  </a>\n</template>\n\n<script>\nexport default {\n  name: \"DarkMode\",\n  data() {\n    return {\n      darkMode: null\n    };\n  },\n  mounted() {\n    if (localStorage.getItem(\"darkMode\") == 'true') {\n      this.darkMode = true;\n    } else {\n      this.darkMode = false;\n    }\n    this.checkColorScheme();\n  },\n  methods: {\n    switchColorScheme(bool) {\n      const el = document.querySelector(\"body\");\n      if (bool) {\n        localStorage.setItem(\"darkMode\", true);\n        el.classList.add(\"theme-dark\");\n      } else {\n        localStorage.setItem(\"darkMode\", false);\n        el.classList.remove(\"theme-dark\");\n      }\n    },\n    checkColorScheme() {\n      if (\n        window.matchMedia &&\n        window.matchMedia(\"(prefers-color-scheme: dark)\").matches &&\n        localStorage.getItem(\"darkMode\") === null\n      ) {\n        this.darkMode = true;\n      }\n    }\n  },\n  watch: {\n    darkMode: function(val) {\n      console.log(\"eseguo\");\n      this.switchColorScheme(val);\n    }\n  }\n};\n</script>\n\n<style lang=\"scss\">\n.action {\n  cursor: pointer;\n}\n</style>",".action {\n  cursor: pointer;\n}\n\n/*# sourceMappingURL=DarkMode.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

// Import vue component

// Declare install function executed by Vue.use()
function install(Vue) {
	if (install.installed) { return; }
	install.installed = true;
	Vue.component('DarkMode.vue', __vue_component__);
}

// Create module definition for Vue.use()
var plugin = {
	install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}

export default __vue_component__;
export { install };
